import React from "react";
import { Users } from "phosphor-react";
import styles from "./MultiSelectNoContent.module.css";

const MultiSelectNoContent = (props) => (
  <div className={styles.noContent}>
    <Users color="rgba(55,81,157, 1)" size={32} />
    <span>{props.message}</span>
  </div>
);

export default MultiSelectNoContent;
